import { type BoardObjectsTransform } from './types'

export const removeBoardObject =
  (boardObjectId: string): BoardObjectsTransform =>
  (draft) => {
    draft.data = draft.data.filter((bo) => bo.id !== boardObjectId)
    return draft
  }
